module.exports = __webpack_public_path__ + "static/media/financepic2@2x.f60a4369.png";